/* Mediheal storefront: mobile header layout + BY INGREDIENT hover-only.
   Load after global.js / details-disclosure.js */
(function () {
  if (window.__mhStorefront) return;
  window.__mhStorefront = true;

  var css =
    '.header__left-icons{grid-area:left-icons;display:flex;align-items:center}' +
    'header-drawer{display:flex;align-items:center}' +
    '.header__menu-item--hover-only,.header__menu-item[data-hover-only="true"]{cursor:default}' +
    '@media screen and (min-width:990px){.header__left-icons .header__search{display:none!important}}';
  var style = document.createElement('style');
  style.setAttribute('data-mh-storefront', '1');
  style.textContent = css;
  document.head.appendChild(style);

  function desktop() {
    return window.matchMedia('(min-width: 990px)').matches;
  }

  function markIngredientHoverOnly() {
    document.querySelectorAll('header-menu summary').forEach(function (summary) {
      var text = (summary.textContent || '').toLowerCase();
      var id = (summary.id || '').toLowerCase();
      if (text.indexOf('ingredient') === -1 && id.indexOf('ingredient') === -1) return;
      summary.setAttribute('data-hover-only', 'true');
      summary.removeAttribute('data-href');
      summary.classList.add('header__menu-item--hover-only');
      summary.style.cursor = 'default';
    });
  }

  function layoutHeader() {
    var header = document.querySelector('header.header');
    if (!header) return;
    var drawer = header.querySelector('header-drawer');
    var icons = header.querySelector('.header__icons');
    var search = header.querySelector('.header__search');
    if (!drawer || !icons || !search) return;

    var left = header.querySelector('.header__left-icons');
    if (!left) {
      left = document.createElement('div');
      left.className = 'header__left-icons';
      drawer.parentNode.insertBefore(left, drawer);
      left.appendChild(drawer);
    }

    header.querySelectorAll('header-drawer > shopify-account').forEach(function (el) {
      el.remove();
    });

    var account = icons.querySelector('shopify-account, .header__icon--account');
    if (account) {
      account.classList.remove('small-hide', 'medium-hide', 'large-up-hide');
    }

    var cart = icons.querySelector('.header__icon--cart, #cart-icon-bubble');
    if (desktop()) {
      if (cart) icons.insertBefore(search, cart);
      else icons.insertBefore(search, icons.firstChild);
    } else if (search.parentNode !== left) {
      left.appendChild(search);
    }
  }

  function boot() {
    markIngredientHoverOnly();
    layoutHeader();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('resize', layoutHeader);
  document.addEventListener('shopify:section:load', boot);
})();
